var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.calendar').directive('newEventSchedule', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/new_event_schedule.html.slim'),
    scope: {
      gym: '=',
      classrooms: '=',
      styles: '=',
      eventTypes: '=',
      time: '=',
      onClose: '&',
      eventDefaults: '=',
      eventDefaultId: '='
    },
    controller: ["$scope", "$document", "$timeout", "$rootScope", "$state", "$stateParams", "$modal", "$filter", "$q", "$http", "flash", "loadingAnimation", "EmploymentService", "EventDefaultsService", "EditEventService", "MonthlyOccurrenceOptionsService", "EventService", "EventTypes", "TrainersService", "FeatureAvailabilityService", "GTMService", "ConfirmLeaveUnsavedChangesService", "Events", "MobileApp", "Locations", "isInteger", function($scope, $document, $timeout, $rootScope, $state, $stateParams, $modal, $filter, $q, $http, flash, loadingAnimation, EmploymentService, EventDefaultsService, EditEventService, MonthlyOccurrenceOptionsService, EventService, EventTypes, TrainersService, FeatureAvailabilityService, GTMService, ConfirmLeaveUnsavedChangesService, Events, MobileApp, Locations, isInteger) {
      var buildParams, deregisterRepeatWatcher, getDailySession, getDefaultProximityCheckin, preSelectTrainerAndLocation, reloadEventTypes, reloadLocations, setDailySession, setEventTime, showSessionsExistMessage, validate;
      $scope.permissions = EmploymentService.get().permissions;
      if (!$scope.permissions.manage_events) {
        $state.go('gym.dashboard');
      }
      GTMService.trackPage('Add Event');
      $scope.drawerData = {
        selectedEventTemplate: EventDefaultsService.getEventDefault($scope.eventDefaults, $scope.eventDefaultId)
      };
      $scope.onSelectedTemplateChange = function(template) {
        if ($scope.displayConfirmationOnClose) {
          if (window.confirm("Are you sure? This will reset any changes made.")) {
            $scope.selectTemplate($scope.drawerData.selectedEventTemplate);
            return $scope.drawerData.prevSelectedEventTemplate = template;
          } else {
            return $scope.drawerData.selectedEventTemplate = $scope.drawerData.prevSelectedEventTemplate;
          }
        } else {
          $scope.selectTemplate($scope.drawerData.selectedEventTemplate);
          return $scope.drawerData.prevSelectedEventTemplate = template;
        }
      };
      $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
      $scope.event = {};
      $scope.minuteStep = 5;
      $scope.trainers = TrainersService.get();
      $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
      $scope.eventRepeatIntervalUnits = EditEventService.getEventRepeatIntervalUnits();
      $scope.restrictCancellationsUnits = EditEventService.getRestrictCancellationsUnits();
      $scope.bookingsAllowedAfterUnits = EditEventService.getBookingsAllowedAfterUnits();
      $scope.eventColors = colorPickerColors;
      $scope.days = EditEventService.getDays();
      $scope.isCustomColorSelected = function() {
        var ref;
        return $scope.event.color && (ref = $scope.event.color, indexOf.call($scope.eventColors, ref) < 0);
      };
      buildParams = angular.extend({
        time: $scope.time
      }, $stateParams);
      angular.extend($scope.event, EventDefaultsService.buildScheduleFromTemplate(buildParams, $scope.drawerData.selectedEventTemplate));
      ConfirmLeaveUnsavedChangesService.watch($scope, 'event', {
        closeModal: function() {
          return $scope.close(true);
        }
      });
      $scope.selectTemplate = function(template) {
        $scope.event = EventDefaultsService.buildScheduleFromTemplate(buildParams, template);
        return $timeout(function() {
          return $scope.displayConfirmationOnClose = false;
        });
      };
      $scope.close = function(skipConfirmation) {
        if ($scope.displayConfirmationOnClose && !skipConfirmation) {
          if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
            return $scope.onClose();
          }
        } else {
          return $scope.onClose();
        }
      };
      getDefaultProximityCheckin = function() {
        if ($scope.drawerData.selectedEventTemplate || !$scope.gym.mobile_app_enabled) {
          return;
        }
        return MobileApp.all('settings').getList().then(function(data) {
          $scope.ignoreChangeCheck = true;
          $scope.event.proximity_checkin_enabled = data[0].proximity_checkin_enabled;
          return $timeout(function() {
            return $scope.ignoreChangeCheck = false;
          });
        });
      };
      getDefaultProximityCheckin();
      $scope.isRepeating = function() {
        return !!$scope.event.repeats || !!$scope.event.repeat_until_date || !!$scope.event.infinite;
      };
      $scope.prevStartDate = $scope.event.start_date;
      $scope.updateRecurrenceOptions = function() {
        var result;
        result = MonthlyOccurrenceOptionsService.generateRecurrenceOptions($scope.event, 'event');
        $scope.recurrenceDropdownOptions = result.options;
        return $scope.eventRecurrenceDropdownHint = result.hint;
      };
      $scope.$watch('event.start_date', function(newVal, oldVal) {
        if (!(newVal && newVal !== oldVal)) {
          return;
        }
        return $scope.updateRecurrenceOptions();
      });
      $scope.updateRecurrenceOptions();
      $scope.copyDailySessionWdays = $scope.days.map(function(day, index) {
        if (index < 6) {
          return [index + 1];
        } else {
          return [0];
        }
      });
      $scope.displayCopyWdays = function(days) {
        return days.map(function(day) {
          var dayStr;
          dayStr = $filter('limitTo')($scope.days[day], 3);
          return $filter('capitalize')(dayStr);
        }).join(', ');
      };
      $scope.isCopyDaySelected = function(dayIndex, copyDay) {
        return EditEventService.isCopyDaySelected(dayIndex, copyDay, $scope.copyDailySessionWdays);
      };
      $scope.toggleCopyDay = function(dayIndex, copyDayIndex) {
        return EditEventService.toggleCopyDay(dayIndex, copyDayIndex, $scope.copyDailySessionWdays);
      };
      $scope.copySession = function(day) {
        return EditEventService.copySession($scope.event, day, $scope.copyDailySessionWdays);
      };
      $scope.displayRequireActiveMembershipDescription = function() {
        return EventService.displayRequireActiveMembershipDescription();
      };
      $scope.displayProximityCheckinDescription = function() {
        return EventService.displayProximityCheckinDescription();
      };
      $scope.setColor = function(color) {
        $scope.event.color = color;
        return $scope.event.customColor = void 0;
      };
      $scope.$on('colorpicker-closed', function(currentScope, color) {
        return $timeout(function() {
          return $scope.event.color = color.value;
        });
      });
      $scope.toggleDay = function(index) {
        return EditEventService.toggleDay($scope.event, index);
      };
      $scope.addDailySession = function(index) {
        return $scope.event.daily_sessions[index].push(getDailySession());
      };
      $scope.removeSession = function(dayIndex, sessionIndex) {
        $scope.event.daily_sessions[dayIndex].splice(sessionIndex, 1);
        if (!$scope.event.daily_sessions[dayIndex].length) {
          return $scope.toggleDay(dayIndex);
        }
      };
      $scope.isDaySelected = function(index) {
        return EditEventService.isDaySelected($scope.event, index);
      };
      preSelectTrainerAndLocation = function() {
        var findPreselectedItem;
        findPreselectedItem = function(id, collection) {
          var match;
          match = _.find(collection, function(item) {
            return item.id === id;
          });
          return (match != null ? match.id : void 0) || collection[0].id;
        };
        $scope.active_classrooms = [];
        if ($scope.classrooms.length) {
          $scope.active_classrooms = $scope.classrooms.filter(function(locn) {
            return locn.active === true;
          });
        }
        if ($scope.active_classrooms.length) {
          $scope.event.classroom_id = findPreselectedItem(+$stateParams.location_id, $scope.active_classrooms);
        }
        if ($scope.unableToManageOtherContacts) {
          return $scope.event.instructor_ids = [window.currentUser.id];
        } else {
          if ($scope.trainers.length) {
            return $scope.event.instructor_ids = [findPreselectedItem(+$stateParams.instructor_id, $scope.trainers)];
          }
        }
      };
      preSelectTrainerAndLocation();
      $scope.removeRepeat = function() {
        return EditEventService.removeRepeat($scope.event);
      };
      $scope.onIntervalUnitChanged = function() {
        EditEventService.onIntervalUnitChanged($scope.event);
        if ($scope.event.repeat_interval_unit === 'week') {
          return $scope.prevStartDate = $scope.event.start_date;
        }
      };
      $scope.onStartDateChanged = function() {
        var day, prevDailySession, prevDay;
        if ($scope.event.repeat_interval_unit === 'week') {
          day = $scope.eventDay();
          prevDay = moment($scope.prevStartDate).day();
          prevDailySession = $scope.event.daily_sessions[prevDay];
          if (prevDailySession != null ? prevDailySession.length : void 0) {
            $scope.event.wdays = _.uniq(_.without($scope.event.wdays, prevDay).concat([day]));
            $scope.event.daily_sessions[prevDay] = void 0;
            $scope.event.daily_sessions[day] = prevDailySession;
          } else {
            setDailySession(day);
          }
          return $scope.prevStartDate = $scope.event.start_date;
        }
      };
      $scope.onEndDateChanged = function() {
        if ($scope.event.repeat_interval_unit === 'week') {
          $scope.event.repeat_type = 'until';
          return $scope.repeatTypeChanged();
        }
      };
      setDailySession = function(day) {
        return EditEventService.setDailySession($scope.event, day);
      };
      getDailySession = function(startTime = $scope.event.start_at_obj) {
        return EditEventService.getDailySession($scope.event, startTime);
      };
      $scope.onEventDurationChanged = function() {
        return _.each($scope.event.daily_sessions, function(day = [], key) {
          return $scope.event.daily_sessions[key] = day.map(function(session) {
            return getDailySession(session.start_at_obj);
          });
        });
      };
      $scope.onDailySessionStartTimeChanged = function(session) {
        return angular.extend(session, getDailySession(session.start_at_obj));
      };
      $scope.onWaitlistToggle = function() {
        if (!$scope.event.waitlist_enabled) {
          return $scope.event.waitlist_limit = void 0;
        }
      };
      $scope.eventDay = function() {
        return moment($scope.event.start_date).day();
      };
      showSessionsExistMessage = function() {
        var date;
        date = moment($scope.event.start_date).format('DD MMM YYYY');
        return window.alert(`Sessions already exist for this series on ${date}. Please manage your session times directly in the \"Days of the Week\" section at the bottom of the page.`);
      };
      $scope.isInfinite = function() {
        return $scope.event.repeat_type === 'infinite';
      };
      $scope.toggleInfinite = function() {
        $scope.event.repeat_type = $scope.isInfinite() ? 'until' : 'infinite';
        return $scope.repeatTypeChanged();
      };
      $scope.onRepeatsChanged = function() {
        $scope.event.repeat_type = 'count';
        return $scope.repeatTypeChanged();
      };
      $scope.onEndDateChanged = function() {
        $scope.event.repeat_type = 'until';
        return $scope.repeatTypeChanged();
      };
      $scope.repeatTypeChanged = function() {
        return EditEventService.repeatTypeChanged($scope.event);
      };
      $scope.isParticipantLimitValid = function() {
        return EditEventService.isParticipantLimitValid($scope.event);
      };
      $scope.isFirstStepValid = function() {
        var e;
        e = $scope.event;
        return e.name && $scope.isParticipantLimitValid() && (!e.restrict_cancellations || e.cancel_before_number);
      };
      $scope.isFormReady = function() {
        return !$scope.isLoading && ($scope.event.repeat_interval_unit !== 'week' || !$scope.isRepeating() || EditEventService.isWeeklyEventReady($scope.event));
      };
      validate = function() {
        var deferred, errors;
        deferred = $q.defer();
        errors = {};
        if ($scope.event.event_types_join_attributes) {
          _.each($scope.event.event_types_join_attributes, function(limit, index) {
            var error;
            error = '';
            if (limit.participant_limit > $scope.event.participant_limit) {
              error = 'Should be less than or equal to event participant limit';
            }
            if (!(limit.participant_limit === null || (isInteger(limit.participant_limit) && limit.participant_limit >= 0))) {
              error = 'Is invalid';
            }
            if (error) {
              return errors[`event_types_join_attributes.participant_limit[${index}]`] = [error];
            }
          });
        }
        if (_.isEmpty(errors)) {
          deferred.resolve();
        } else {
          deferred.reject(errors);
        }
        return deferred.promise;
      };
      $scope.save = function() {
        GTMService.trackPage('Add Event', 'attempt');
        return validate().then(function() {
          var ref, ref1, temp_bookings_allowed_after_number, temp_bookings_allowed_after_unit, temp_bookings_allowed_before_number, temp_bookings_allowed_before_unit, temp_cancel_before_number, temp_cancel_before_unit;
          if (((ref = $scope.event.repeat_interval_unit) === 'day' || ref === 'week' || ref === 'month') && !$scope.isRepeating()) {
            flash.error = 'Please specify how long this event should continue for';
            return;
          }
          if (((ref1 = $scope.event.repeat_interval_unit) === 'day' || ref1 === 'week' || ref1 === 'month') && !$scope.event.repeat_interval_number) {
            flash.error = 'Please specify when this event should repeat';
            return;
          }
          $scope.event.errors = (function() {
            switch (false) {
              case !!$scope.event.instructor_ids.length:
                return {
                  instructor: ["Please select a trainer."]
                };
              case !($scope.event.restrict_bookings_before && $scope.event.bookings_allowed_before_number < 1):
                return {
                  bookings_allowed_before_number: ["must be greater than or equal to 1"]
                };
              case !($scope.allow_late_cancellations && $scope.event.late_cancellation_fee && $scope.event.late_cancellation_fee < 1):
                return {
                  late_cancellation_fee: ["must be greater than or equal to 1"]
                };
              default:
                return void 0;
            }
          })();
          if ($scope.event.errors) {
            flash.error = "Update failed. Please fix the errors below";
            return;
          }
          loadingAnimation.show();
          $scope.isLoading = true;
          if (!$scope.event.restrict_cancellations) {
            temp_cancel_before_number = $scope.event.cancel_before_number;
            temp_cancel_before_unit = $scope.event.cancel_before_unit;
            $scope.event.cancel_before_number = void 0;
            $scope.event.cancel_before_unit = void 0;
          }
          if (!$scope.event.restrict_bookings_before) {
            temp_bookings_allowed_before_number = $scope.event.bookings_allowed_before_number;
            temp_bookings_allowed_before_unit = $scope.event.bookings_allowed_before_unit;
            $scope.event.bookings_allowed_before_number = void 0;
            $scope.event.bookings_allowed_before_unit = void 0;
          }
          if (!$scope.event.restrict_bookings_after) {
            temp_bookings_allowed_after_number = $scope.event.bookings_allowed_after_number;
            temp_bookings_allowed_after_unit = $scope.event.bookings_allowed_after_unit;
            $scope.event.bookings_allowed_after_number = void 0;
            $scope.event.bookings_allowed_after_unit = void 0;
          }
          setEventTime();
          return Events.post($scope.event).then(function(model) {
            GTMService.trackPage('Add Event', 'success');
            $scope.close(true);
            loadingAnimation.hide();
            flash.success = 'Event(s) added successfully';
            return $rootScope.$emit('calendar:updated');
          }, function(response) {
            var defaultError, ref2;
            GTMService.trackPage('Add Event', 'error');
            $document.scrollTop(0);
            if (response.data.event_schedule) {
              $scope.event.errors = response.data.event_schedule.errors;
            }
            defaultError = 'Update failed. Please fix the errors below';
            flash.error = response.data.error_message || ((ref2 = response.data.event_schedule) != null ? ref2.error : void 0) || defaultError;
            loadingAnimation.hide();
            $scope.isLoading = false;
            if (!$scope.event.restrict_cancellations) {
              $scope.event.cancel_before_number = temp_cancel_before_number;
              $scope.event.cancel_before_unit = temp_cancel_before_unit;
            }
            if (!$scope.event.restrict_bookings_before) {
              $scope.event.bookings_allowed_before_number = temp_bookings_allowed_before_number;
              $scope.event.bookings_allowed_before_unit = temp_bookings_allowed_before_unit;
            }
            if (!$scope.event.restrict_bookings_after) {
              $scope.event.bookings_allowed_after_number = temp_bookings_allowed_after_number;
              return $scope.event.bookings_allowed_after_unit = temp_bookings_allowed_after_unit;
            }
          });
        }, function(errors) {
          flash.error = "Update failed. Please fix the errors below";
          return $scope.event.errors = errors;
        });
      };
      setEventTime = function() {
        var endTime, startTime;
        if ($scope.event.start_at_obj) {
          startTime = moment($scope.event.start_at_obj).format('HH:mm:ss');
          $scope.event.start_at = `${$scope.event.start_date} ${startTime}`;
        }
        if ($scope.event.end_at_obj) {
          endTime = moment($scope.event.end_at_obj).format('HH:mm:ss');
          return $scope.event.end_at = `${$scope.event.start_date} ${endTime}`;
        }
      };
      reloadEventTypes = function() {
        return EventTypes.getList({
          count: 1000
        }).then(function(types) {
          return $scope.eventTypes = types;
        });
      };
      $scope.manageTypes = function() {
        return EditEventService.manageTypes($scope.eventTypes).result.then(function() {
          return reloadEventTypes();
        }, function() {
          return reloadEventTypes();
        });
      };
      $scope.userChangedEndTime = false;
      $scope.autoSettingEndTime = false;
      deregisterRepeatWatcher = $scope.$watch('event.repeat_interval_unit', function(newVal, oldVal) {
        if (newVal !== 'week' && $scope.drawerData.selectedEventTemplate) {
          $scope.userChangedEndTime = false;
          $scope.autoSettingEndTime = false;
          return deregisterRepeatWatcher();
        }
      });
      $scope.$watch('event.end_at_obj', function(newVal, oldVal) {
        if (!(moment(newVal).isValid() && !moment(newVal).isSame(moment(oldVal)))) {
          return;
        }
        if ($scope.autoSettingEndTime) {
          return $scope.autoSettingEndTime = false;
        } else {
          return $scope.userChangedEndTime = true;
        }
      });
      $scope.$watch('event.start_at_obj', function(newVal, oldVal) {
        if (!(moment(newVal).isValid() && !moment(newVal).isSame(moment(oldVal)))) {
          return;
        }
        if (!$scope.userChangedEndTime) {
          $scope.autoSettingEndTime = true;
          return $scope.event.end_at_obj = moment(newVal).add(60, 'minutes').toDate();
        }
      });
      $scope.onEventTypeChange = function() {
        return $scope.event.event_types_join_attributes = $scope.event.event_type_ids.map(function(typeId) {
          var limit, type;
          type = $scope.event.event_types_join_attributes ? _.find($scope.event.event_types_join_attributes, function(item) {
            return item.id === typeId;
          }) : void 0;
          limit = (type != null ? type.participant_limit : void 0) !== void 0 ? type.participant_limit : null;
          return {
            id: typeId,
            participant_limit: limit
          };
        });
      };
      $scope.getEventTypeName = function(id) {
        var type;
        type = _.find($scope.eventTypes, function(item) {
          return item.id === id;
        });
        return type != null ? type.name : void 0;
      };
      $scope.getErrorsByIndex = function(key, index) {
        var ref;
        return (ref = $scope.event.errors) != null ? ref[`${key}[${index}]`] : void 0;
      };
      reloadLocations = function() {
        return Locations.getList({
          count: 200
        }).then(function(response) {
          return $scope.classrooms = response;
        });
      };
      $scope.manageLocations = function() {
        return EditEventService.manageLocations($scope.classrooms).result.then(function() {
          return reloadLocations();
        }, function() {
          return reloadLocations();
        });
      };
      $scope.eventAppearanceTooltip = EventService.eventAppearanceTooltip();
      $scope.nameTooltip = EventService.nameTooltip();
      $scope.maxAttendeesTooltip = EventService.maxAttendeesTooltip();
      $scope.maxPropspectsTooltip = EventService.maxPropspectsTooltip();
      return $scope.trainerTooltip = EventService.trainerTooltip();
    }]
  };
});
